import { AutogenLayoutCarrierActivityList } from "./autogen/AutogenLayoutCarrierActivityList";

export class CarrierActivityList extends AutogenLayoutCarrierActivityList {
    onLoad(): void | Promise<void> {
        this.tableCarrierActivities.addButtonCaption = "Add Carrier Activity";
    }
}
